import { Category } from '@gripp/shared-logic';
import { useState } from 'react';
import { View } from 'react-native';
import { Chip, Menu } from 'react-native-paper';
import {
  CategoryChip,
  useCategoryChipStyle,
  getCategoryChipTextStyle,
} from './categoryChip';
import { themedStyleSheet } from '../../themes/themedStyleSheet';

type CategoryChipMenuProps = {
  categories: Category[];
  onPress?: (categoryId: string) => Promise<void>;
  chipLength?: number;
};

export const CategoryChipMenu = (props: CategoryChipMenuProps) => {
  const chipStyle = useCategoryChipStyle();
  const [visible, setVisible] = useState(false);
  const openMenu = () => setVisible(true);
  const closeMenu = () => setVisible(false);

  const onPress = async (categoryId: string) => {
    if (props.onPress) {
      await props.onPress(categoryId);
      closeMenu();
    }
  };

  return (
    <Menu
      visible={visible}
      onDismiss={closeMenu}
      contentStyle={styles.categoryMenuContent}
      anchor={
        <Chip
          onPress={openMenu}
          textStyle={getCategoryChipTextStyle()}
          style={chipStyle}
        >
          {`+${props.chipLength ?? props.categories.length - 1}`}
        </Chip>
      }
    >
      {props.categories.map((category) => (
        <View
          key={props.categories.indexOf(category)}
          style={styles.categoryChipMenuItemContainer}
        >
          <CategoryChip category={category} onPress={onPress} />
        </View>
      ))}
    </Menu>
  );
};

const styles = themedStyleSheet((role) => ({
  categoryChipMenuItemContainer: {
    marginVertical: 5,
    marginHorizontal: 15,
  },
  categoryMenuContent: {
    backgroundColor: role.surface,
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
    textAlign: 'center',
    top: 30,
    right: 40,
  },
}));
